export enum Tab {
  Chat,
  Search,
}

export enum Sender {
  User = "User",
  Nemo = "Nemo",
}

export const STREAMING_CURSOR = "●";
